// Account Receivable Statements States
import i18n from '@/i18n'

export default {
  statementsList: [],
  statementInfo: {},
  cashOrOpen: [
    { text: i18n.t('On Account'), value: 'Cash' },
    { text: i18n.t('Opening Balance'), value: 'Opening Balance' }
  ]
}
